module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseErrors"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      staticClass: "BaseErrors__item"
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03dd68ff"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseErrors.vue
// module id = 491
// module chunks = 1